<template>
  <div>
    <v-tabs center-active v-model="selectedTab">
      <v-tab v-for="(tab, idx) in tabOptions" :return-value="true" :key="idx">
        {{ tab }}
      </v-tab>
      <!-- <v-icon>mdi-minus</v-icon> -->
    </v-tabs>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      tabOptions: ["mídias", "notícias", "enquetes", "câmeras", "cronômetro"],
      selectedTab: this.$store.state.moderacao.modoModeracao,
    };
  },
  methods: {
    ...mapActions({
      setModoModeracao: "moderacao/setModoModeracao",
    }),
  },
  watch: {
    selectedTab: function (newValue) {
      localStorage.setItem("@socialcam/modoModeracao", newValue);
      this.setModoModeracao(this.selectedTab);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tabs {
  background: transparent !important;
}

.v-tab {
  font-size: 1.1rem;
  color: #9e9e9e !important;
  font-weight: 400;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
  }
}

.v-tab--active {
  color: var(--v-primary-base) !important;
  font-weight: 700;
}
</style>
